import {
  KontentFilterable,
  KontentFilterInputs,
} from "types/CMS/Unum/filterable";
import {
  ResolverOptions,
  Resolver,
  ResolvedWithFilter,
} from "types/CMS/Unum/resolver";

export const isResolverFilterable = <TResolved>(
  data: TResolved
): data is TResolved & KontentFilterable => {
  if (Array.isArray(data)) {
    return data.every(
      (item) => (item as KontentFilterable)?.isFilterable === true
    );
  }
  return (data as KontentFilterable)?.isFilterable === true;
};

// Factory to create a resolver
export const createResolver = <TInput, TResolved>(
  options: ResolverOptions<TInput, TResolved>
): Resolver<TInput, TResolved> => {
  return {
    resolve: (input: TInput, filters?: KontentFilterInputs) => {
      const data = options.resolve(input, filters);

      if (isResolverFilterable(data)) {
        return createResolvedFilterable(data);
      }

      return { result: data };
    },
  } as Resolver<TInput, TResolved>;
};

// Factory to create a filterable resolved result
const createResolvedFilterable = <TResolved>(
  data: TResolved | undefined
): ResolvedWithFilter<TResolved | undefined> => {
  return {
    result: data,
    filter: (fn) => {
      if (Array.isArray(data)) {
        const filteredArray = data.filter(
          (item) => item && fn(item)
        ) as TResolved;
        return createResolvedFilterable(filteredArray);
      }

      const match = fn(data as any);
      return createResolvedFilterable(match ? data : undefined);
    },
  };
};
